import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, renderList as _renderList, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a87a57c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 2,
  style: {"color":"red"}
}
const _hoisted_2 = {
  key: 3,
  style: {"color":"red"}
}
const _hoisted_3 = {
  key: 4,
  style: {"color":"red"}
}
const _hoisted_4 = {
  key: 5,
  style: {"color":"red"}
}
const _hoisted_5 = {
  key: 6,
  style: {"color":"red"}
}
const _hoisted_6 = {
  key: 7,
  style: {"color":"red"}
}
const _hoisted_7 = {
  key: 8,
  style: {"color":"red"}
}
const _hoisted_8 = {
  key: 9,
  style: {"color":"red"}
}
const _hoisted_9 = {
  key: 10,
  style: {"color":"red"}
}
const _hoisted_10 = {
  key: 0,
  style: {"color":"#fec25a"}
}
const _hoisted_11 = {
  key: 1,
  class: "theme-color",
  style: {"color":"#2f7bff"}
}
const _hoisted_12 = {
  key: 2,
  style: {"color":"#94c730"}
}
const _hoisted_13 = {
  key: 3,
  style: {"color":"#969696"}
}
const _hoisted_14 = {
  key: 4,
  style: {"color":"#969696"}
}
const _hoisted_15 = {
  key: 5,
  style: {"color":"#969696"}
}
const _hoisted_16 = { key: 6 }

export function render(_ctx, _cache) {
  const _component_flow_status_tab = _resolveComponent("flow-status-tab")
  const _component_list_query_header = _resolveComponent("list-query-header")
  const _component_export_btn = _resolveComponent("export-btn")
  const _component_a_space = _resolveComponent("a-space")
  const _component_table_flow_btn_new = _resolveComponent("table-flow-btn-new")
  const _component_table_wrapper = _resolveComponent("table-wrapper")
  const _component_hmd_list_page = _resolveComponent("hmd-list-page")
  const _directive_perm = _resolveDirective("perm")

  return (_openBlock(), _createBlock(_component_hmd_list_page, null, {
    header: _withCtx(() => [
      (!_ctx.isIframe)
        ? (_openBlock(), _createBlock(_component_flow_status_tab, {
            key: 0,
            ref: "flowTabRef",
            flowStatus: _ctx.status,
            "onUpdate:flowStatus": _cache[0] || (_cache[0] = $event => ((_ctx.status) = $event)),
            bizCode: _ctx.bizType
          }, null, 8, ["flowStatus", "bizCode"]))
        : _createCommentVNode("", true),
      (!_ctx.isIframe)
        ? (_openBlock(), _createBlock(_component_list_query_header, {
            key: 1,
            formModel: _ctx.queryRef,
            "onUpdate:formModel": _cache[1] || (_cache[1] = $event => ((_ctx.queryRef) = $event)),
            search: _ctx.search,
            loading: _ctx.loading,
            labelWidth: 110,
            onSetTableHeight: _ctx.setTableHeight,
            onReset: _ctx.reset
          }, {
            form: _withCtx(({appendToParent}) => [
              _renderSlot(_ctx.$slots, "query", { appendToParent: appendToParent }, undefined, true)
            ]),
            _: 3
          }, 8, ["formModel", "search", "loading", "onSetTableHeight", "onReset"]))
        : _createCommentVNode("", true)
    ]),
    body: _withCtx(() => [
      (_openBlock(), _createBlock(_component_table_wrapper, {
        dataSource: _ctx.dataSource,
        onOnTableChange: _ctx.onTableChange,
        onOnSelectionChange: _ctx.onSelectionChange,
        pagination: _ctx.pagination,
        tableHeight: _ctx.tableHeight,
        loading: _ctx.loading,
        columns: _ctx.tableColumn,
        key: _ctx.childKey,
        flowStatus: _ctx.status,
        showCustomSetting: _ctx.showCustomSetting,
        ref: "tableRef",
        onLastTimeEvent: _ctx.lastTimeEvent,
        timeSort: true,
        bizType: _ctx.bizType
      }, _createSlots({
        buttons: _withCtx(() => [
          _createVNode(_component_a_space, null, {
            default: _withCtx(() => [
              (!_ctx.isDeletedStatus)
                ? _renderSlot(_ctx.$slots, "tableButtons", { key: 0 }, undefined, true)
                : _createCommentVNode("", true),
              (_ctx.exportConfig)
                ? _withDirectives((_openBlock(), _createBlock(_component_export_btn, {
                    key: 1,
                    api: _ctx.exportConfig.api,
                    selectedIds: _ctx.selectedIds,
                    queryRef: _ctx.queryRef,
                    tableColumn: _ctx.exportColumn,
                    isRecycled: _ctx.isDeletedStatus
                  }, null, 8, ["api", "selectedIds", "queryRef", "tableColumn", "isRecycled"])), [
                    [_directive_perm, _ctx.exportConfig.premKey]
                  ])
                : _createCommentVNode("", true),
              (_ctx.filterTotalAmount)
                ? (_openBlock(), _createElementBlock("span", _hoisted_1, "当前条件下总金额：" + _toDisplayString(_ctx.filterTotalAmount) + "元", 1))
                : _createCommentVNode("", true),
              (_ctx.bizType == 'settlement_examine')
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, "选中总金额：" + _toDisplayString(_ctx.allTotalMoney) + "元", 1))
                : _createCommentVNode("", true),
              (_ctx.bizType == 'receipt_examine')
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, "选中总金额：" + _toDisplayString(_ctx.allTotalMoney) + "元", 1))
                : _createCommentVNode("", true),
              (_ctx.bizType == 'payment_order_external_examine')
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, "选中总金额：" + _toDisplayString(_ctx.allTotalMoney) + "元", 1))
                : _createCommentVNode("", true),
              (_ctx.bizType == 'margin_payment_examine')
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, "选中总金额：" + _toDisplayString(_ctx.allTotalMoney) + "元", 1))
                : _createCommentVNode("", true),
              (_ctx.bizType == 'margin_return_examine')
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, "选中总金额：" + _toDisplayString(_ctx.allTotalMoney) + "元", 1))
                : _createCommentVNode("", true),
              (_ctx.bizType == 'expense_account_examine')
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "选中总金额：" + _toDisplayString(_ctx.allTotalMoney) + "元", 1))
                : _createCommentVNode("", true),
              (_ctx.bizType == 'make_invoice_examine')
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "选中总金额：" + _toDisplayString(_ctx.allTotalMoney) + "元", 1))
                : _createCommentVNode("", true),
              (_ctx.bizType == 'income_invoice_examine')
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, "选中总金额：" + _toDisplayString(_ctx.allTotalMoney) + "元", 1))
                : _createCommentVNode("", true)
            ]),
            _: 3
          })
        ]),
        flowStatusName: _withCtx(({ record } ) => [
          (record.flowStatus=='dtj')
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(record.flowStatusName), 1))
            : (record.flowStatus=='spz')
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(record.flowStatusName), 1))
              : (record.flowStatus=='sptg')
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(record.flowStatusName), 1))
                : (record.flowStatus=='spbtg')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(record.flowStatusName), 1))
                  : (record.flowStatus=='ycx')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(record.flowStatusName), 1))
                    : (record.flowStatus=='yzf')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(record.flowStatusName), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(record.flowStatusName), 1))
        ]),
        operation: _withCtx(({record}) => [
          _createVNode(_component_table_flow_btn_new, {
            record: record,
            operationExternalData: _ctx.operationExternalData,
            flowConfig: _ctx.flowConfig,
            bizType: _ctx.bizType,
            bizNameKey: _ctx.bizNameKey,
            recycleBinConfig: _ctx.recycleBinConfig,
            onRefresh: _ctx.refresh,
            flowStatusTab: _ctx.status,
            statusKey: _ctx.statusKey,
            other: _ctx.other
          }, null, 8, ["record", "operationExternalData", "flowConfig", "bizType", "bizNameKey", "recycleBinConfig", "onRefresh", "flowStatusTab", "statusKey", "other"])
        ]),
        _: 2
      }, [
        _renderList(_ctx.tableSlot, (index, name) => {
          return {
            name: name,
            fn: _withCtx((data) => [
              _renderSlot(_ctx.$slots, name, {
                record:  data?data.record:{}
              }, undefined, true)
            ])
          }
        })
      ]), 1032, ["dataSource", "onOnTableChange", "onOnSelectionChange", "pagination", "tableHeight", "loading", "columns", "flowStatus", "showCustomSetting", "onLastTimeEvent", "bizType"]))
    ]),
    _: 3
  }))
}